import FormControl from '@mui/material/FormControl';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
import FieldLabel from '../fields/FieldLabel';
import ReactSelect, { SelectValue } from '../policy/fields/ReactSelect';

interface SelectOptions {
	value: string;
	label: string;
}

interface Props {
	title: string;
	hasError?: boolean;
	type?: string;
	uri?: string;
	options: SelectOptions[];
	required?: boolean;
	value?: string;
	disabled?: boolean;
	onUpdate: (uri: string, type: string, value: string) => void;
}

const useStyles = makeStyles((theme) => ({
	disabledInput: {
		'& .MuiInputBase-root.Mui-disabled': {
			color: 'rgba(0, 0, 0, 0.54)',
		},
	},
}));

const SelectField = (props: Props) => {
	const classes = useStyles();
	const {
		title,
		hasError,
		type,
		required,
		options,
		uri,
		disabled,
		value,
		onUpdate,
	} = props;
	const initialValue = value || '';
	const initialOption = options.find((op) => op.value === initialValue);
	const initialLabel = initialOption ? initialOption.label : '';
	const [fieldValue, setFieldValue] = React.useState({ value: '', label: '' });

	React.useEffect(() => {
		const fieldVal = disabled
			? { value, label: initialLabel }
			: { value: initialValue, label: initialLabel };

		setFieldValue(fieldVal);
	}, [disabled, value]);

	const onChange = (val: any) => {
		setFieldValue(val);
		onUpdate(uri, type, val.value);
	};

	return (
		<FormControl style={{ width: '100%', marginTop: '16px' }}>
			<FieldLabel title={title} required={required} />
			<ReactSelect
				className={classes.disabledInput}
				error={hasError}
				id={uri}
				options={options.map((v) => ({ value: v.value, label: v.label }))}
				value={fieldValue}
				isDisabled={disabled}
				onChange={(opt: SelectValue) => onChange(opt)}
				includeEmptyValue
			/>
		</FormControl>
	);
};

export default SelectField;
